module.exports = __webpack_public_path__ + "static/media/tareq-ajalyakin-hgs-WgmT8GA-unsplash.19bcb9f8.jpg";